import { render, staticRenderFns } from "./UserTabDetails.vue?vue&type=template&id=635bed71&scoped=true"
import script from "./UserTabDetails.vue?vue&type=script&lang=ts"
export * from "./UserTabDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635bed71",
  null
  
)

export default component.exports